// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  OperationResponse,
  OperationDisplay,
  ExceptionResponse,
  ServiceError,
  ServiceErrorDetail,
  QuotaRequestDetails,
  QuotaRequestProperties,
  KnownQuotaRequestState,
  QuotaRequestState,
  SubRequest,
  ResourceName,
  LimitJsonObject,
  LimitJsonObjectUnion,
  KnownLimitType,
  LimitType,
  LimitObject,
  KnownQuotaLimitTypes,
  QuotaLimitTypes,
  ExtensionResource,
  Resource,
  SystemData,
  KnownCreatedByType,
  CreatedByType,
  GroupQuotasEntity,
  GroupQuotasEntityProperties,
  GroupQuotasEntityBase,
  KnownGroupType,
  GroupType,
  KnownRequestState,
  RequestState,
  ProxyResource,
  ErrorResponse,
  ErrorDetail,
  ErrorAdditionalInfo,
  GroupQuotasEntityPatch,
  GroupQuotasEntityPatchProperties,
  GroupQuotasEntityBasePatch,
  SubmittedResourceRequestStatus,
  SubmittedResourceRequestStatusProperties,
  GroupQuotaRequestBase,
  GroupQuotaRequestBaseProperties,
  GroupQuotaRequestBasePropertiesName,
  GroupQuotaLimitList,
  GroupQuotaLimitListProperties,
  GroupQuotaLimit,
  GroupQuotaLimitProperties,
  GroupQuotaDetails,
  GroupQuotaDetailsName,
  AllocatedQuotaToSubscriptionList,
  AllocatedToSubscription,
  ResourceUsages,
  GroupQuotaUsagesBase,
  GroupQuotaUsagesBaseName,
  GroupQuotaSubscriptionId,
  GroupQuotaSubscriptionIdProperties,
  GroupQuotaSubscriptionRequestStatus,
  GroupQuotaSubscriptionRequestStatusProperties,
  SubscriptionQuotaAllocationsList,
  SubscriptionQuotaAllocationsListProperties,
  SubscriptionQuotaAllocations,
  SubscriptionQuotaAllocationsProperties,
  SubscriptionQuotaDetails,
  SubscriptionQuotaDetailsName,
  QuotaAllocationRequestStatus,
  QuotaAllocationRequestStatusProperties,
  QuotaAllocationRequestBase,
  QuotaAllocationRequestBaseProperties,
  QuotaAllocationRequestBasePropertiesName,
  GroupQuotasEnforcementStatus,
  GroupQuotasEnforcementStatusProperties,
  KnownEnforcementState,
  EnforcementState,
  CurrentUsagesBase,
  UsagesProperties,
  UsagesObject,
  KnownUsagesTypes,
  UsagesTypes,
  CurrentQuotaLimitBase,
  QuotaProperties,
  KnownVersions,
} from "./models.js";
